<script lang="ts">
    import { afterUpdate } from 'svelte';
    import Sortable from '../../utilities/sortable';
    import { fade } from 'svelte/transition';

    import WidgetTemplate from './WidgetTemplate.svelte';
    import { WidgetManager } from './WidgetManager';
    import CreateNewWidget from './CreateNewWidget/CreateNewWidget.svelte';

    export let widgetManager: WidgetManager;
    export let addWidget: () => void = () => {};

    let sortable: any;
    let dashboardList: HTMLDivElement;

    afterUpdate(() => {
        sortable = Sortable.create(dashboardList, {
            handle: '.sortable-item-handle',
            animation: 350,
            onEnd: function () {
                let order = sortable.toArray('data-id');
                console.log('order', order);
                widgetManager.setOrder(order);
                widgetManager.save();
            },
        });
    });
</script>

<div class="widget-list" bind:this={dashboardList}>
    {#if widgetManager}
        {#each widgetManager.getComponents() as { id, component, settings, settingsOptions } (id)}
            {#if typeof widgetManager.getDashboardItem(id) !== 'undefined'}
                <div
                    class="dashboard-item"
                    class:full-width-item={settingsOptions.fullWidth}
                    class:double-height-item={settingsOptions.doubleHeight}
                    data-id={id}
                    in:fade={{ duration: 150 }}
                    out:fade={{ duration: 150 }}
                >
                    <WidgetTemplate
                        bind:widgetManager
                        dashboardItem={widgetManager.getDashboardItem(id)}
                    >
                        <svelte:component
                            this={component}
                            {id}
                            bind:widgetManager
                            dashboardItem={widgetManager.getDashboardItem(id)}
                        />
                    </WidgetTemplate>
                </div>
            {/if}
        {:else}
            <div class="dashboard-item" data-id={0} in:fade={{ duration: 150 }}>
                <WidgetTemplate {widgetManager}>
                    <CreateNewWidget {addWidget} />
                </WidgetTemplate>
            </div>
        {/each}
    {/if}
</div>

<style>
    .widget-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
        gap: 1rem;
        margin-right: 20px;
    }
    .dashboard-item {
        min-height: 260px;
    }
    .dashboard-item.full-width-item {
        grid-column: 1 / -1; /* Spans from the first column line to the last column line */
    }
    .dashboard-item.double-height-item {
        min-height: 420px;
    }
</style>
